import './PortProductCertificates.css'
import 'antd/dist/reset.css'
import React from 'react'
import Certificates3 from '../../../images/certificate/certificates_3.jpeg'

export default class PortExtraCertificates extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <div className="PortProductCertificates">
        <img className="PortProductCertificatesImage" src={Certificates3} />
        <div className="PortProductCertificatesText">
          <div className="PortProductCertificatesName">
            职业健康安全管理体系认证证书
          </div>
          <div className="PortProductCertificatesContent">
            职业健康安全管理体系认证证书是第三方机构对企业职业健康安全管理体系符合国际标准（如ISO
            45001）的正式认可证明。它表明企业已建立系统化的安全管理机制，能够有效识别和控制职业健康安全风险，预防工伤事故和职业病，保障员工健康与安全。
          </div>
        </div>
      </div>
    )
  }
}
